import { BASE_URL } from '../BASE_URL';

export const getDesigner = async (id) => {
  const response = await fetch(BASE_URL + `brands/designers/${id}`, {
    method: 'GET',
  });
  const data = await response.json();
  return data;
};
